import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'

export default () => {
  return (
    <DataView module={Constants.module.RESTAURANT} object={Constants.donnee.table_categorie}/>
  )
}



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Restaurant/GestionTable/index.js